module.exports = __webpack_public_path__ + "static/img/galaxy.822fe81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/galaxy.jpg
// module id = Rl+J
// module chunks = 0